export default "__VITE_ASSET__CFzmh7YG__"